// Dependencies
import React, { Component } from "react";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";

// Store
import { vppsStore } from "../store/store";

// Components
import VppsList from "./VppsList/VppsList.component";
import Footer from "../../home/components/Footer/footer.component";

// Styles
import "./VppsPage.component.scss";

class VppsPage extends Component {
    render() {
        return (
            <Provider store={vppsStore}>
                <div id="VppsPage">
                    <Switch>
                        <Route exact path={"/vpp"} component={VppsList} />
                    </Switch>
                    <Footer />
                </div>
            </Provider>
        );
    }
}

export default VppsPage;
